
import {
    ApiCall
} from './index';

export const DOCUMENTS = ({id, query}) => `/documents/${id}${query}`;

export const getDocuments = async(data) => {
    return await ApiCall('GET', DOCUMENTS(data), null);
};



// WEBPACK FOOTER //
// ./src/services/document.js